import React from 'react';
import {
  ViewButton,
  EditButton,
  ImpersonateButton,
} from '../Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabels,
  getSort,
} from '../Common/DataTable/tableHelpers';
import moment from 'moment';
import FromNow from '../Common/FromNow';
import assignAllowedRoles from '../../config/assignAllowedRoles';

const createTableColumns = (
  openViewModal,
  openEditModal,
  handleImpersonateUser,
  acquisitionOrders,
  user,
  companyId,
  isImpersonating,
) => [
  {
    title: 'Display Name',
    name: 'displayName',
    width: 150,
  },
  {
    title: 'Email',
    name: 'email',
    width: 200,
  },
  {
    title: 'Role',
    name: 'role',
    width: 120,
  },
  {
    title: 'Exchange Number',
    name: 'phoneExchangeId',
    width: 150,
  },
  {
    title: 'Acquisition Orders',
    name: 'acquisitionOrderIds',
    getCellValue: (row) =>
      getLabels(row.acquisitionOrderIds?.[companyId], acquisitionOrders),
  },
  {
    title: 'Active',
    name: 'active',
    width: 100,
    getCellValue: (row) => (row.active ? 'yes' : 'no'),
    formatterComponent: ({ value }) =>
      value === 'yes' ? (
        <span className="badge badge-success font-size-12">YES</span>
      ) : (
        <span className="badge badge-danger font-size-12">NO</span>
      ),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => <FromNow value={value} />,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
    exportValue: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm:ss'),
  },
  {
    title: 'Action',
    name: 'action',
    width: 180,
    align: 'center',
    formatterComponent: ({ row }) => {
      const allowedRolesForCurrentUser = assignAllowedRoles[user.role] || [];
      const canImpersonate =
        !isImpersonating &&
        row.active &&
        user.id !== row.id &&
        row.role !== user.role &&
        allowedRolesForCurrentUser.includes(row.role);

      return (
        <ul className="list-inline font-size-20 contact-links mb-0">
          <ViewButton row={row} onPress={openViewModal} />
          {(user.role !== row.role || user.id === row.id) && (
            <EditButton row={row} onPress={openEditModal} />
          )}
          {canImpersonate && (
            <ImpersonateButton row={row} onPress={handleImpersonateUser} />
          )}
        </ul>
      );
    },
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
